// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"7b8a3eee","34":"91c2c61c","152":"f5859141","312":"e935db4c","399":"64e6c5d5","453":"7279bcfa","471":"34392f3d","885":"2a15742c"}[chunkId] + ".chunk.js";
};